module.exports = __webpack_public_path__ + "img/img_company@2x.ba20ffca.png";